import Skeleton from '@mui/material/Skeleton';
import { Card, CollapsibleCard, DataGrid, SectionTitle } from 'modules/shared/components';
import {
  BUILDING_TYPE_LABELS,
  PROJECT_STATUS_MAP,
  WORK_AGE_LABELS,
  WORK_CATEGORY,
  WORK_CATEGORY_LABELS,
} from 'modules/work-implementation/constants';

const getBasicDetailsColumns = (projectData) => [
  {
    rows: [
      { label: 'Project Name', value: projectData.name },
      { label: 'Project Date', value: projectData.date },
    ],
  },
  {
    rows: [
      {
        label: 'Site Address',
        render: () => <span className='pre-styled-text'>{projectData.siteAddress}</span>,
      },
      { label: 'Locality', value: projectData.locality },
    ],
  },
];

const getTypeOfWorkColumns = (typeOfWork) => {
  const hasAlliedWork =
    typeOfWork.workCategory === WORK_CATEGORY.ALLIED ||
    typeOfWork.workCategory === WORK_CATEGORY.ALLIED_BUILDING;
  const hasBuildingWork =
    typeOfWork.workCategory === WORK_CATEGORY.BUILDING ||
    typeOfWork.workCategory === WORK_CATEGORY.ALLIED_BUILDING;
  return [
    {
      rows: [
        { label: 'Work Type', value: WORK_AGE_LABELS[typeOfWork.workAge] },

        ...(hasAlliedWork
          ? [
              {
                label: 'Allied Work Details',
                value: typeOfWork.alliedWorkDetails,
              },
            ]
          : []),
      ],
    },
    {
      rows: [
        {
          label: 'Work Category',
          value: WORK_CATEGORY_LABELS[typeOfWork.workCategory],
        },
        ...(hasBuildingWork
          ? [
              {
                label: 'Building Type',
                value: BUILDING_TYPE_LABELS[typeOfWork.buildingType] ?? typeOfWork.buildingType,
              },
            ]
          : []),
      ],
    },
  ];
};

export default function CommonDetails({ loading, projectData = {} }: { loading?: any; projectData?: Record<string, any> }) {
  if (loading) {
    return <Skeleton variant='rounded' width='100%' height={40} />;
  }

  const basicDetailsColumns = getBasicDetailsColumns(projectData);
  const typeOfWorkColumns = getTypeOfWorkColumns(projectData?.typeOfWork || {});

  return (
    <>
      <Card>
        <div className='row row--between'>
          <span>Job Code: {projectData.code}</span>
          <span>{projectData.name}</span>
          <span>{projectData.timeLeft}</span>
          <span>{PROJECT_STATUS_MAP[projectData.status] ?? projectData.status}</span>
        </div>
      </Card>

      <CollapsibleCard
        title={<SectionTitle title='Project Details' />}
        colorVariant='default'
        borderVariant='outlined'
      >
        <div className='column gap-3'>
          <div className='column'>
            <span className='font-medium'>Basic Details</span>
            <DataGrid columns={basicDetailsColumns} />
          </div>

          <div className='column'>
            <span className='font-medium'>Type of Work</span>
            <DataGrid columns={typeOfWorkColumns} />
          </div>
        </div>
      </CollapsibleCard>
    </>
  );
}
